import {
    Animations,
    FootnoteRegular,
    H2Emphasized,
    H6Regular,
    Image,
    Shadows,
    YStack,
} from 'smoothie';

import BookGeneralSession from '../../../assets/images/guidance_sessions/book_general_session.png';
import { useViewEvents } from '../../events/hooks/useViewEvents';
import { SUPPORT_EMAIL } from '../../settings/types/constants';

const UpgradePlanWidget = () => {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('UpgradePlanWidget');

    return (
        <YStack
            {...Animations.FadeIn}
            $sm={{
                flex: 1,
            }}
        >
            <H6Regular marginBottom={12}>Sessions</H6Regular>
            <YStack
                alignItems="flex-start"
                gap={6}
                backgroundColor="$peach300"
                borderRadius={12}
                paddingHorizontal={22}
                paddingVertical={22}
                {...Shadows.SMALL}
            >
                <H2Emphasized>Want to book more sessions?</H2Emphasized>
                <FootnoteRegular paddingRight={20} color="$gray1100">
                    {`Upgrade your membership for access to more 1-on-1 sessions with your Guide. Contact our Hospitality team at ${SUPPORT_EMAIL} to learn more.`}
                </FootnoteRegular>
                <Image
                    source={BookGeneralSession}
                    width={106}
                    height={88}
                    alignSelf="flex-end"
                    marginTop={8}
                />
            </YStack>
        </YStack>
    );
};

export default UpgradePlanWidget;
